import VizWrapper from "@components/common/Base/VizWrapper";
import Title from "@components/common/Title";
import useIcons from "@hooks/use-source-icons";
import {
  BentoGridDynamicZoneModel,
  BentoGridVariant,
} from "@models/strapi-components/bento-grid";
import React from "react";
import { twMerge } from "tailwind-merge";
export interface BentoGridPropsModel {
  componentData: BentoGridDynamicZoneModel;
}

const variantBasedClass: Record<BentoGridVariant, Record<string, string>> = {
  [BentoGridVariant.BASE]: {
    wrapperClassName: "",
    titleWrapperClassName: "md:max-w-[50%]",
    titleClassName: "",
    subTitleClassName: "",
    subTitleWrapperClassName: "md:max-w-[70%]",
    bentoWrapperClassName: "",
    oneBentoWrapperClassName: "",
    iconWrapperClassName: "",
  },
  [BentoGridVariant.CENTERED]: {
    wrapperClassName: "flex flex-col items-center",
    titleWrapperClassName: "text-center md:max-w-[70%] mx-auto",
    titleClassName: "text-center max-w-[80%] mx-auto",
    subTitleClassName: "max-w-[70%] mx-auto text-center",
    subTitleWrapperClassName: "text-center md:max-w-[70%] mx-auto",
    bentoWrapperClassName:
      "mt-8 items-center justify-center grid grid-cols-2 md:flex md:flex-wrap",
    oneBentoWrapperClassName:
      "flex flex-col items-center max-w-[180px] sm:max-w-[282px]",
    iconWrapperClassName:
      "p-4 rounded-full flex justify-center items-center mb-3",
  },
};

const BentoGrid: React.FunctionComponent<BentoGridPropsModel> = ({
  componentData,
}) => {
  const {
    title,
    bgColor,
    bentos,
    subTitle,
    variant = BentoGridVariant.BASE,
  } = componentData ?? {};
  const { getFromReactIcons } = useIcons();
  const {
    titleWrapperClassName,
    subTitleWrapperClassName,
    bentoWrapperClassName,
    oneBentoWrapperClassName,
    iconWrapperClassName,
    titleClassName,
    subTitleClassName,
  } = variantBasedClass[variant] ?? {};

  return (
    <VizWrapper
      className={twMerge("lg:px-[140px] xl:px-[180px] flex flex-col")}
      style={{ backgroundColor: bgColor }}
    >
      <div className={twMerge("", titleWrapperClassName)}>
        <Title variant="h2" titleText={title} />
      </div>
      <div className={twMerge("", subTitleWrapperClassName)}>
        <Title variant="paragraph" titleText={subTitle} />
      </div>
      <div
        className={twMerge(
          "flex flex-wrap gap-12 xl:max-w-[1000px] mx-auto",
          bentoWrapperClassName
        )}
      >
        {bentos?.map((bento) => {
          const { id, title, subTitle, icon, color } = bento;
          const Icon = getFromReactIcons(icon);
          return (
            <div key={id} className={twMerge("", oneBentoWrapperClassName)}>
              <div
                className={iconWrapperClassName}
                style={{
                  backgroundColor:
                    variant === BentoGridVariant.CENTERED
                      ? color
                      : "transparent",
                }}
              >
                {Icon && <Icon size={28} className="" />}
              </div>
              <Title
                titleText={title}
                variant="h3"
                className={titleClassName}
              />
              <Title
                titleText={subTitle}
                variant="paragraph"
                className={subTitleClassName}
              />
            </div>
          );
        })}
      </div>
    </VizWrapper>
  );
};

export default BentoGrid;
